/**
 * @generated SignedSource<<e84edd9ed4885898046ac248e188c047>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CartChannel = "businessshop" | "personalshop" | "personalss" | "sparkdigitalshop";
export type BottomBarMpdPromotionsQuery$variables = {
  channel: CartChannel;
  offerIds: ReadonlyArray<string>;
};
export type BottomBarMpdPromotionsQuery$data = {
  readonly mpdPromotions: {
    readonly bundles: ReadonlyArray<{
      readonly id: string;
      readonly items: ReadonlyArray<{
        readonly id: string;
        readonly price: ReadonlyArray<{
          readonly basePrice: number;
          readonly basePriceExcludingTax: number | null;
          readonly discount: {
            readonly appliedValue: number;
            readonly appliedValueExcludingTax: number | null;
            readonly discountedValue: number;
            readonly discountedValueExcludingTax: number | null;
          } | null;
          readonly effectivePrice: number;
          readonly effectivePriceExcludingTax: number | null;
        }>;
        readonly productOfferingId: string;
      }>;
    }>;
    readonly price: ReadonlyArray<{
      readonly basePrice: number;
      readonly basePriceExcludingTax: number | null;
      readonly discount: {
        readonly appliedValue: number;
        readonly appliedValueExcludingTax: number | null;
        readonly discountedValue: number;
        readonly discountedValueExcludingTax: number | null;
      } | null;
      readonly effectivePrice: number;
      readonly effectivePriceExcludingTax: number | null;
    }>;
  };
};
export type BottomBarMpdPromotionsQuery = {
  response: BottomBarMpdPromotionsQuery$data;
  variables: BottomBarMpdPromotionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "channel"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offerIds"
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "MpdPromotionsPrice",
  "kind": "LinkedField",
  "name": "price",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "basePrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "basePriceExcludingTax",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "effectivePrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "effectivePriceExcludingTax",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Discount",
      "kind": "LinkedField",
      "name": "discount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "appliedValue",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "appliedValueExcludingTax",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "discountedValue",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "discountedValueExcludingTax",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "channel",
        "variableName": "channel"
      },
      {
        "kind": "Variable",
        "name": "offerIds",
        "variableName": "offerIds"
      }
    ],
    "concreteType": "MpdPromotionsResponse",
    "kind": "LinkedField",
    "name": "mpdPromotions",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "MpdPromotionsBundle",
        "kind": "LinkedField",
        "name": "bundles",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MpdPromotionsBundleItem",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "productOfferingId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "BottomBarMpdPromotionsQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "BottomBarMpdPromotionsQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "9a7fab29e652373fd877242c8f7d36b4",
    "id": null,
    "metadata": {},
    "name": "BottomBarMpdPromotionsQuery",
    "operationKind": "query",
    "text": "query BottomBarMpdPromotionsQuery(\n  $offerIds: [String!]!\n  $channel: CartChannel!\n) {\n  mpdPromotions(offerIds: $offerIds, channel: $channel) {\n    price {\n      basePrice\n      basePriceExcludingTax\n      effectivePrice\n      effectivePriceExcludingTax\n      discount {\n        appliedValue\n        appliedValueExcludingTax\n        discountedValue\n        discountedValueExcludingTax\n      }\n    }\n    bundles {\n      id\n      items {\n        id\n        price {\n          basePrice\n          basePriceExcludingTax\n          effectivePrice\n          effectivePriceExcludingTax\n          discount {\n            appliedValue\n            appliedValueExcludingTax\n            discountedValue\n            discountedValueExcludingTax\n          }\n        }\n        productOfferingId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b63c6559e26b8a9ba9fde4a00097e6a2";

export default node;
